import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import Notify from 'quasar/src/plugins/notify/Notify.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';;

// To be used on app.use(Quasar, { ... })
export default {
  plugins: {
    Notify,
    Loading,
    Dialog,
  },
  config: {
    notify: { /* look at QuasarConfOptions from the API card */ },
    loading: { /* look at QuasarConfOptions from the API card */ },
  },
};
